import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Flex } from 'antd';

import { ReactComponent as IconLogo } from 'assets/images/icon-logo.svg';

import { SIdentity, SLogoText, SLogoWrapper } from './style';

interface ILogo {
  role?: string;
  userName?: string;
}

export const Logo = ({ role, userName }: ILogo) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const redirectToHome = () => {
    navigate('/');
  };

  const identity = [role, userName].filter(Boolean).join(': ');

  return (
    <SLogoWrapper gap={12} align="center" onClick={redirectToHome}>
      <IconLogo width={44} height={44} />
      <Flex vertical justify="center">
        <SLogoText>{t('adminCabinet')}</SLogoText>
        {identity && <SIdentity>{identity}</SIdentity>}
      </Flex>
    </SLogoWrapper>
  );
};
